<template>
  <div class="home">
    <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
    <PurchasingList v-show="listView" @newPurchasing="onClickNewFromList" @editPurchasing="onClickEditFromList" @returnPurchasing="onClickReturnFromList" :scroll="corY" ref="refreshList"/>
    <PurchasingForm v-show="formView" :purchasing="purchasing" :uom_type_list="uom_type_list" @backClicked="onBackChild" @backSaveChild="onBackSaveChild" @backClickID ="onBackParentID" @onPayment="onClickPaymentFromForm"/>
    <PurchasingPayment v-show="paymentView" :purchasing="purchasing" @backClicked="onBackChild" @backSaveClicked="onBackSaveChild" @cancelPayment="cancelPayment" @savePayment="onClickEditFromList" />
    <PurchasingRetur v-show="returnView" :purchasing="purchasing" @backClicked="onBackChild" />
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import PurchasingList from '@/components/purchasing/PurchasingList.vue'
import PurchasingForm from '@/components/purchasing/PurchasingForm.vue'
import PurchasingPayment from '@/components/purchasing/PurchasingPayment.vue'
import PurchasingRetur from '@/components/purchasing/PurchasingRetur.vue'
import Loading from 'vue-loading-overlay'
import { purchasingUrl, getHeader } from '../config'
import { mapState } from 'vuex'

export default {
  name: 'Purchasing',
  components: {
    PurchasingList,
    PurchasingForm,
    PurchasingPayment,
    PurchasingRetur,
    Loading
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      paymentView: false,
      returnView: false,
      uom_type_list: [{
        id: null,
        name: null,
        category_id: null,
        type_id: null,
        ratio: null,
        active: false
      }],
      purchasing: {
        id: null,
        purchasing_no: null,
        purchasing_date: null,
        purchasing_due_date: null,
        term_due_id: '',
        ref_no: null,
        branch_no: null,
        vendor_no: null,
        vendor: {
          id: null,
          vendor_no: null,
          name: null,
          phone: null,
          address: null
        },
        subtotal: '0',
        tax_id: null,
        tax: '0',
        discount: '0',
        total: '0',
        delivery_cost: '0',
        deliver_no: null,
        status: null,
        branch: null,
        type_id: null,
        lock: null,
        company_no: null,
        ext_no: null,
        sp_no: null,
        notes: null,
        deliver_date: null,
        faktur_no: null,
        faktur_date: null,
        faktur_process_date: null,
        details: [{
          id: null,
          purchasing_no: null,
          purchasing_date: null,
          branch_no: null,
          product_no: null,
          product: null,
          description: null,
          qty: null,
          qty_done: null,
          uom_id: null,
          price: '0',
          tax_id: null,
          tax: '0',
          discount: '0',
          subtotal: '0',
          total: '0',
          order_no: null,
          edit: false,
          uomList: [{
            id: null,
            name: null,
            ratio: '0',
            category: null
          }]
        }],
        payment: [{
          id: null,
          payment_no: null,
          purchasing_no: null,
          payment_date: null,
          price: '0',
          method_id: null,
          method: null,
          type_id: null,
          type: null,
          bank_id: null,
          bank: null,
          account_no: null,
          notes: null
        }],
        logs: [{
          id: null,
          log_date: null,
          ref_no: null,
          user_id: null,
          user: null,
          description: null
        }],
        journals: [{
          id: null,
          level: null,
          journal_code: null,
          journal_date: null,
          status: null,
          journal_description: null,
          account_code: null,
          account: null,
          remark: null,
          debit: null,
          credit: null
        }],
        inventory: [{
          id: null,
          inventory_no: null,
          type_id: null,
          inventory_date: null,
          notes: null,
          warehouse_no: null,
          warehouse: null,
          company_no: null,
          company: null,
          details: [{
            id: null,
            inventory_no: null,
            serial_number: null,
            sec_serial_number: null,
            product_no: null,
            product_sku: null,
            product: null,
            warehouse_no: null,
            uom_id: null,
            qty_demand: null,
            qty_done: null,
            inventory_date: null,
            branch_no: null,
            company_no: null,
            expired_date: null,
            internal_no: null,
            cost: null,
            vendor_no: null,
            receive_finish: false
          }]
        }],
        returns: [{
          id: null,
          type: null,
          return_no: null,
          return_date: null,
          deliver_date: null,
          purchasing_no: null,
          sale_no: null,
          notes: null,
          status: null,
          branch_no: null,
          branch: null,
          company_no: null,
          company: null,
          lock: null,
          is_deliver: null,
          customer_no: null,
          customer: null,
          vendor_no: null,
          vendor: {
            id: null,
            vendor_no: null,
            name: null,
            phone: null,
            address: null
          },
          subtotal: '0',
          discount: '0',
          discount_percentage: '0',
          tax_id: null,
          tax: '0',
          total: '0',
          details: [{
            id: null,
            return_no: null,
            product_no: null,
            product: null,
            product_sku: null,
            serial_number: null,
            uom_id: null,
            qty: null,
            amount: '0',
            notes: null,
            warehouse_no: null,
            warehouse: null,
            branch_no: null,
            company_no: null,
            discount: '0',
            discount_percentage: '0',
            tax_id: null,
            tax: '0',
            subtotal: '0',
            total: '0',
            return_date: null,
            cost: '0',
            cost_id: null
          }]
        }],
        order: [{
          id: null,
          purchasing_no: null,
          purchasing_date: null,
          purchasing_due_date: null,
          ref_no: null,
          branch_no: null,
          vendor_no: null,
          vendor: null,
          subtotal: null,
          tax_id: null,
          tax: '0',
          discount: '0',
          total: '0',
          delivery_cost: '0',
          deliver_no: null,
          status: null,
          type_id: null,
          lock: false,
          company_no: null,
          company: null,
          term_due_id: null,
          ext_no: null,
          sp_no: null,
          details: [{
            id: null,
            purchasing_no: null,
            purchasing_date: null,
            branch_no: null,
            branch: null,
            product_no: null,
            product: null,
            product_sku: null,
            description: null,
            qty: null,
            qty_done: null,
            uom_id: null,
            price: null,
            tax_id: null,
            tax: '0',
            discount: '0',
            subtotal: '0',
            total: '0',
            company_no: null,
            company: null,
            vendor_no: null,
            vendor: null
          }]
        }]
      },
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      }
    }
  },
  methods: {
    onClickReturnFromList (value) {
      this.listView = false
      this.formView = false
      this.paymentView = false
      this.returnView = true
      this.purchasing = value
      this.purchasing.returns[0].tax_id = this.purchasing.tax_id
    },
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.paymentView = false
      this.returnView = false
      this.purchasing = value
    },
    getEditPurchasing: function (value) {
      this.$Progress.start()
      this.loader.isLoading = true
      axios.get(purchasingUrl + '/' + value, { headers: getHeader() })
        .then(response => {
          this.listView = false
          this.formView = true
          this.paymentView = false
          this.returnView = false
          this.purchasing = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.paymentView = false
      this.returnView = false
      var date = new Date()
      var details = []
      var company = this.companyList.find(d => d.company_no === this.authUser.company_no)
      var taxid = company ? company.tax_id : null
      // for (let i = 1; i < 10; i++) {
      //   var obj = {
      //     purchasing_no: null,
      //     purchasing_date: null,
      //     branch_no: null,
      //     product_no: null,
      //     product: null,
      //     description: null,
      //     qty: 1,
      //     qty_done: 0,
      //     uom_id: null,
      //     price: '0',
      //     tax_id: taxid,
      //     tax: '0',
      //     discount: '0',
      //     discount_percentage: '0',
      //     subtotal: '0',
      //     total: '0',
      //     company_no: null,
      //     vendor_no: null,
      //     uomList: [{
      //       id: null,
      //       name: null,
      //       ratio: '0',
      //       category: null
      //     }]
      //   }
      //   details.push(obj)
      // }
      this.purchasing = {
        id: null,
        purchasing_no: null,
        purchasing_date: date.toISOString(),
        purchasing_due_date: null,
        term_due_id: '1',
        ref_no: null,
        branch_no: null,
        vendor_no: null,
        subtotal: '0',
        tax_id: taxid,
        tax: '0',
        discount: '0',
        total: '0',
        delivery_cost: '0',
        deliver_no: null,
        status: null,
        branch: this.authUser.branch_no,
        vendor: {
          id: null,
          vendor_no: null,
          name: null,
          phone: null,
          address: null
        },
        type_id: 1,
        lock: false,
        company_no: this.authUser.company_no,
        ext_no: null,
        sp_no: null,
        notes: null,
        deliver_date: null,
        faktur_no: null,
        faktur_date: null,
        faktur_process_date: null,
        details: details,
        payment: [{
          id: null,
          payment_no: null,
          purchasing_no: null,
          payment_date: null,
          price: '0',
          method_id: null,
          method: null,
          type_id: null,
          type: null,
          bank_id: null,
          bank: null,
          account_no: null,
          notes: null
        }],
        logs: [{
          id: null,
          log_date: null,
          ref_no: null,
          user_id: null,
          user: null,
          description: null
        }],
        journals: [{
          id: null,
          level: null,
          journal_code: null,
          journal_date: null,
          status: null,
          journal_description: null,
          account_code: null,
          account: null,
          remark: null,
          debit: null,
          credit: null
        }],
        inventory: [{
          id: null,
          inventory_no: null,
          type_id: null,
          inventory_date: null,
          notes: null,
          warehouse_no: null,
          warehouse: null,
          company_no: null,
          company: null,
          details: [{
            id: null,
            inventory_no: null,
            serial_number: null,
            sec_serial_number: null,
            product_no: null,
            product_sku: null,
            product: null,
            warehouse_no: null,
            uom_id: null,
            qty_demand: null,
            qty_done: null,
            inventory_date: null,
            branch_no: null,
            company_no: null,
            expired_date: null,
            internal_no: null,
            cost: null,
            vendor_no: null,
            receive_finish: false
          }]
        }],
        order: [{
          id: null,
          purchasing_no: null,
          purchasing_date: null,
          purchasing_due_date: null,
          ref_no: null,
          branch_no: null,
          vendor_no: null,
          vendor: null,
          subtotal: null,
          tax_id: null,
          tax: '0',
          discount: '0',
          total: '0',
          delivery_cost: '0',
          deliver_no: null,
          status: null,
          type_id: null,
          lock: false,
          company_no: null,
          company: null,
          term_due_id: null,
          ext_no: null,
          sp_no: null,
          details: [{
            id: null,
            purchasing_no: null,
            purchasing_date: null,
            branch_no: null,
            branch: null,
            product_no: null,
            product: null,
            product_sku: null,
            description: null,
            qty: '0',
            qty_done: '0',
            uom_id: null,
            price: '0',
            tax_id: null,
            tax: '0',
            discount: '0',
            subtotal: '0',
            total: '0',
            company_no: null,
            company: null,
            vendor_no: null,
            vendor: null
          }]
        }],
        returns: [{
          id: null,
          type: null,
          return_no: null,
          return_date: null,
          deliver_date: null,
          purchasing_no: null,
          sale_no: null,
          notes: null,
          status: null,
          branch_no: null,
          branch: null,
          company_no: null,
          company: null,
          lock: null,
          is_deliver: null,
          customer_no: null,
          customer: null,
          vendor_no: null,
          vendor: {
            id: null,
            vendor_no: null,
            name: null,
            phone: null,
            address: null
          },
          subtotal: '0',
          discount: '0',
          discount_percentage: '0',
          tax_id: null,
          tax: '0',
          total: '0',
          details: [{
            id: null,
            return_no: null,
            product_no: null,
            product: null,
            product_sku: null,
            serial_number: null,
            uom_id: null,
            qty: null,
            amount: '0',
            notes: null,
            warehouse_no: null,
            warehouse: null,
            branch_no: null,
            company_no: null,
            discount: '0',
            discount_percentage: '0',
            tax_id: null,
            tax: '0',
            subtotal: '0',
            total: '0',
            return_date: null,
            cost: '0',
            cost_id: null
          }]
        }]
      }
    },
    async onBackParentID (id) {
      await axios.get(purchasingUrl + '/' + id, { headers: getHeader() })
        .then(response => {
          console.log('onBackParentID')
          var x = window.pageXOffset
          var y = window.pageYOffset
          this.corX = x
          this.corY = y
          window.scrollTo(0, 0)
          this.listView = false
          this.formView = true
          this.paymentView = false
          this.returnView = false
          this.purchasing = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error!!!', error.response.data.message, 'error')
          throw error
        })
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.paymentView = false
      this.returnView = false
      this.purchasing = {
        id: null,
        purchasing_no: null,
        purchasing_date: null,
        purchasing_due_date: null,
        term_due_id: '',
        ref_no: null,
        branch_no: null,
        vendor_no: null,
        subtotal: '0',
        tax_id: null,
        tax: '0',
        discount: '0',
        total: '0',
        delivery_cost: '0',
        deliver_no: null,
        status: null,
        branch: null,
        vendor: {
          id: null,
          vendor_no: null,
          name: null,
          phone: null,
          address: null
        },
        type_id: null,
        lock: false,
        company_no: null,
        ext_no: null,
        sp_no: null,
        notes: null,
        deliver_date: null,
        faktur_no: null,
        faktur_date: null,
        faktur_process_date: null,
        details: [{
          id: null,
          purchasing_no: null,
          purchasing_date: null,
          branch_no: null,
          product_no: null,
          product: null,
          description: null,
          qty: null,
          qty_done: null,
          uom_id: null,
          price: '0',
          tax_id: null,
          tax: '0',
          discount: '0',
          subtotal: '0',
          total: '0',
          order_no: null,
          edit: false,
          uomList: [{
            id: null,
            name: null,
            ratio: '0',
            category: null
          }]
        }],
        payment: [{
          id: null,
          payment_no: null,
          purchasing_no: null,
          payment_date: null,
          price: '0',
          method_id: null,
          type_id: null,
          bank_id: null,
          notes: null
        }],
        logs: [{
          id: null,
          log_date: null,
          ref_no: null,
          user_id: null,
          user: null,
          description: null
        }],
        journals: [{
          id: null,
          level: null,
          journal_code: null,
          journal_date: null,
          status: null,
          journal_description: null,
          account_code: null,
          account: null,
          remark: null,
          debit: null,
          credit: null
        }],
        inventory: [{
          id: null,
          inventory_no: null,
          type_id: null,
          inventory_date: null,
          notes: null,
          warehouse_no: null,
          warehouse: null,
          company_no: null,
          company: null,
          details: [{
            id: null,
            inventory_no: null,
            serial_number: null,
            sec_serial_number: null,
            product_no: null,
            product_sku: null,
            product: null,
            warehouse_no: null,
            uom_id: null,
            qty_demand: null,
            qty_done: null,
            inventory_date: null,
            branch_no: null,
            company_no: null,
            expired_date: null,
            internal_no: null,
            cost: null,
            vendor_no: null,
            receive_finish: false,
            uomList: [{
              id: null,
              name: null,
              ratio: '0',
              category: null
            }]
          }]
        }],
        order: [{
          id: null,
          purchasing_no: null,
          purchasing_date: null,
          purchasing_due_date: null,
          ref_no: null,
          branch_no: null,
          vendor_no: null,
          vendor: null,
          subtotal: null,
          tax_id: null,
          tax: '0',
          discount: '0',
          total: '0',
          delivery_cost: '0',
          deliver_no: null,
          status: null,
          type_id: null,
          lock: false,
          company_no: null,
          company: null,
          term_due_id: null,
          ext_no: null,
          sp_no: null,
          details: [{
            id: null,
            purchasing_no: null,
            purchasing_date: null,
            branch_no: null,
            branch: null,
            product_no: null,
            product: null,
            product_sku: null,
            description: null,
            qty: null,
            qty_done: null,
            uom_id: null,
            price: null,
            tax_id: null,
            tax: '0',
            discount: '0',
            subtotal: '0',
            total: '0',
            company_no: null,
            company: null,
            vendor_no: null,
            vendor: null
          }]
        }],
        returns: [{
          id: null,
          type: null,
          return_no: null,
          return_date: null,
          deliver_date: null,
          purchasing_no: null,
          sale_no: null,
          notes: null,
          status: null,
          branch_no: null,
          branch: null,
          company_no: null,
          company: null,
          lock: null,
          is_deliver: null,
          customer_no: null,
          customer: null,
          vendor_no: null,
          vendor: null,
          subtotal: '0',
          discount: '0',
          discount_percentage: '0',
          tax_id: null,
          tax: '0',
          total: '0',
          details: [{
            id: null,
            return_no: null,
            product_no: null,
            product: null,
            product_sku: null,
            serial_number: null,
            uom_id: null,
            qty: null,
            amount: '0',
            notes: null,
            warehouse_no: null,
            warehouse: null,
            branch_no: null,
            company_no: null,
            discount: '0',
            discount_percentage: '0',
            tax_id: null,
            tax: '0',
            subtotal: '0',
            total: '0',
            return_date: null,
            cost: '0',
            cost_id: null
          }]
        }]
      }
      const query = Object.assign({}, this.$route.query)
      if (query) {
        delete query.purchasing
        delete query.form
        // this.$router.replace({ query })
      }
      // this.$router.replace({ path: 'purchasing', query: null })
    },
    onBackSaveChild () {
      this.listView = true
      this.formView = false
      this.paymentView = false
      this.returnView = false
      this.purchasing = {
        id: null,
        purchasing_no: null,
        purchasing_date: null,
        purchasing_due_date: null,
        term_due_id: '',
        ref_no: null,
        branch_no: null,
        vendor_no: null,
        subtotal: '0',
        tax_id: null,
        tax: '0',
        discount: '0',
        total: '0',
        delivery_cost: '0',
        deliver_no: null,
        status: null,
        branch: null,
        vendor: {
          id: null,
          vendor_no: null,
          name: null,
          phone: null,
          address: null
        },
        type_id: null,
        lock: false,
        company_no: null,
        ext_no: null,
        sp_no: null,
        notes: null,
        deliver_date: null,
        faktur_no: null,
        faktur_date: null,
        faktur_process_date: null,
        details: [{
          id: null,
          purchasing_no: null,
          purchasing_date: null,
          branch_no: null,
          product_no: null,
          product: null,
          description: null,
          qty: null,
          qty_done: null,
          uom_id: null,
          price: '0',
          tax_id: null,
          tax: '0',
          discount: '0',
          subtotal: '0',
          total: '0',
          order_no: null,
          edit: false,
          uomList: [{
            id: null,
            name: null,
            ratio: '0',
            category: null
          }]
        }],
        payment: [{
          id: null,
          payment_no: null,
          purchasing_no: null,
          payment_date: null,
          price: '0',
          method_id: null,
          type_id: null,
          bank_id: null,
          notes: null
        }],
        logs: [{
          id: null,
          log_date: null,
          ref_no: null,
          user_id: null,
          user: null,
          description: null
        }],
        journals: [{
          id: null,
          level: null,
          journal_code: null,
          journal_date: null,
          status: null,
          journal_description: null,
          account_code: null,
          account: null,
          remark: null,
          debit: null,
          credit: null
        }],
        inventory: [{
          id: null,
          inventory_no: null,
          type_id: null,
          inventory_date: null,
          notes: null,
          warehouse_no: null,
          warehouse: null,
          company_no: null,
          company: null,
          details: [{
            id: null,
            inventory_no: null,
            serial_number: null,
            sec_serial_number: null,
            product_no: null,
            product_sku: null,
            product: null,
            warehouse_no: null,
            uom_id: null,
            qty_demand: null,
            qty_done: null,
            inventory_date: null,
            branch_no: null,
            company_no: null,
            expired_date: null,
            internal_no: null,
            cost: null,
            vendor_no: null,
            receive_finish: false
          }]
        }],
        order: [{
          id: null,
          purchasing_no: null,
          purchasing_date: null,
          purchasing_due_date: null,
          ref_no: null,
          branch_no: null,
          vendor_no: null,
          vendor: null,
          subtotal: null,
          tax_id: null,
          tax: '0',
          discount: '0',
          total: '0',
          delivery_cost: '0',
          deliver_no: null,
          status: null,
          type_id: null,
          lock: false,
          company_no: null,
          company: null,
          term_due_id: null,
          ext_no: null,
          sp_no: null,
          details: [{
            id: null,
            purchasing_no: null,
            purchasing_date: null,
            branch_no: null,
            branch: null,
            product_no: null,
            product: null,
            product_sku: null,
            description: null,
            qty: null,
            qty_done: null,
            uom_id: null,
            price: null,
            tax_id: null,
            tax: '0',
            discount: '0',
            subtotal: '0',
            total: '0',
            company_no: null,
            company: null,
            vendor_no: null,
            vendor: null
          }]
        }],
        returns: [{
          id: null,
          type: null,
          return_no: null,
          return_date: null,
          deliver_date: null,
          purchasing_no: null,
          sale_no: null,
          notes: null,
          status: null,
          branch_no: null,
          branch: null,
          company_no: null,
          company: null,
          lock: null,
          is_deliver: null,
          customer_no: null,
          customer: null,
          vendor_no: null,
          vendor: null,
          subtotal: '0',
          discount: '0',
          discount_percentage: '0',
          tax_id: null,
          tax: '0',
          total: '0',
          details: [{
            id: null,
            return_no: null,
            product_no: null,
            product: null,
            product_sku: null,
            serial_number: null,
            uom_id: null,
            qty: null,
            amount: '0',
            notes: null,
            warehouse_no: null,
            warehouse: null,
            branch_no: null,
            company_no: null,
            discount: '0',
            discount_percentage: '0',
            tax_id: null,
            tax: '0',
            subtotal: '0',
            total: '0',
            return_date: null,
            cost: '0',
            cost_id: null
          }]
        }]
      }
      const query = Object.assign({}, this.$route.query)
      if (query) {
        delete query.purchasing
        delete query.form
      }
      this.$refs.refreshList.refreshPurchasing()
    },
    onClickPaymentFromForm: function (value) {
      this.purchasing = value
      this.paymentView = true
      this.returnView = false
      this.listView = false
      this.formView = false
    },
    cancelPayment: function (id) {
      this.getEditPurchasing(id)
    }
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser,
      companyList: state => state.companies.companyList,
      taxList: state => state.taxes.taxList
    })
  },
  mounted () {
    this.$store.dispatch('getTermDueList')
    this.$store.dispatch('getVendorList')
    this.$store.dispatch('getBranchList')
    this.$store.dispatch('getTaxList')
    this.$store.dispatch('getUomList')
    this.$store.dispatch('getRowTable')
    this.$store.dispatch('getPaymentTypeList')
    this.$store.dispatch('getPaymentMethodList')
    this.$store.dispatch('getPurchasingTypeList')
    this.$store.dispatch('getBankList')
    this.$store.dispatch('getPurchasingTypeList')
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getWarehouseList')
    this.$store.dispatch('getChartOfAccountList')
    this.$store.dispatch('getSettingList')
    this.$store.dispatch('getProductListSelect', { status: null })
    // get query param from url
    var form = this.$route.query.form
    var purchasing = this.$route.query.purchasing
    if (form === 'true') {
      if (purchasing !== null) {
        this.getEditPurchasing(purchasing)
      }
    }
  }
}
</script>
